export class LoadClientPersonHistoryEntity {
    
    id: number;
    customerId: number;
    creationDate: Date;
    userId: number;
    
    constructor (){}
}